//import { useTranslation } from "react-i18next";

export const Email = () => {
  //const { t } = useTranslation();

  return <div>Hello 👋, I am a Email component.</div>;
};
